import { Box, Flex, Image, Text } from '@cmpsr/components';
import Marquee from 'react-fast-marquee';

const socialProofs = [
  {
    name: 'Zoe',
    imageSrc: 'images/social-proof/mini-proof-people/zoe.jpg',
    percentage: 39.5,
    cancerType: 'Breast',
    testimonial:
      "My mom had breast cancer, so I've always been scared it could happen to me too. Catch showed me l was at risk— but also gave me a clear plan. Seeing that 39% drop in my risk was the first time I felt like I was actually in control of my health.",
  },

  {
    name: 'Kevin',
    imageSrc: 'images/social-proof/mini-proof-people/leo.jpg',
    percentage: 45.1,
    cancerType: 'Prostate',
    testimonial:
      "I never thought prostate cancer would be something I needed to worry about. But the biomarker test caught things early, and Catch gave me the lifestyle tools to change my risk. Now I feel like I'm aging on my terms.",
  },
  {
    name: 'Maria',
    imageSrc: 'images/social-proof/mini-proof-people/nina.jpg',
    percentage: 32.4,
    cancerType: 'Colon',
    testimonial:
      'Colon cancer runs in my family. When Catch flagged it as a high risk, I panicked. But the way they broke down my plan - with screenings, supplements, even recipe changes - helped my lower that risk.',
  },
  {
    name: 'Daniel',
    imageSrc: 'images/social-proof/mini-proof-people/miles.jpg',
    percentage: 29,
    cancerType: 'Overall',
    testimonial:
      "I joined Catch because I was tired of waiting for something to go wrong. Now I know my risks, I track them every month, and I've cut my overall cancer risk by almost 30%. That's more peace of mind than any doctor ever gave me.",
  },
  {
    name: 'Malik',
    imageSrc: 'images/social-proof/mini-proof-people/malik.jpg',
    percentage: 35.7,
    cancerType: 'Neck',
    testimonial:
      'I never imagined lifestyle habits were putting me at risk for neck cancer. Catch opened my eyes — and gave me the knowledge to shift my daily routine. Seeing that drop in my risk score? Huge confidence boost.',
  },
  {
    name: 'Emily',
    imageSrc: 'images/social-proof/mini-proof-people/clara.jpg',
    percentage: 40.5,
    cancerType: 'Cervical',
    testimonial:
      'I was shocked when Catch told me how high my cervical cancer risk was. I felt empowered with my action plan. After biomarker tests, screenings, and steps I could actually stick to. My risk is much lower and I felt relieved.',
  },
];

function SocialProofCard({ socialProof }: { socialProof: (typeof socialProofs)[0] }) {
  return (
    <Flex
      backgroundColor="#F0F5F6"
      w="330px"
      flexDirection="column"
      gap="0.5rem"
      alignItems="center"
      p="32px"
      borderRadius="1rem"
    >
      <Image src={socialProof.imageSrc} alt={socialProof.name} />
      <Text textTransform="capitalize" fontSize="1.20988rem" fontWeight="400" lineHeight="130%">
        {socialProof.cancerType} cancer risk
      </Text>
      <Flex justifyContent="center">
        <Flex bg="green" alignItems="center" gap="0.5rem" p="0.5rem" borderRadius="0.5rem">
          <Image src="images/icons/arrow-down.svg" alt="arrow down" />
          <Text fontSize="1.3rem" fontStyle="italic" lineHeight="1.1615rem" fontFamily="libreBaskerville">
            {socialProof.percentage}%
          </Text>
        </Flex>
      </Flex>
      <Text fontSize="0.84694rem" fontWeight="400" lineHeight="140%">
        "{socialProof.testimonial}"
      </Text>
      <Text fontSize="0.84694rem" fontWeight="400" lineHeight="140%">
        {socialProof.name}, Catch Member
      </Text>
    </Flex>
  );
}

export function SocialProofMarquee() {
  return (
    <Box w="100%">
      <Marquee speed={40} gradient={false} direction="left" autoFill={true}>
        <Flex gap="4rem" mx="2rem">
          {socialProofs.map((socialProof) => (
            <SocialProofCard key={socialProof.name} socialProof={socialProof} />
          ))}
        </Flex>
      </Marquee>
    </Box>
  );
}
